import { routerDeleteCall } from '../../axios';

const deleteDigitalSalesApplication = (state, params) => {
  const url = `/accounts/deleteApplication`;
  return routerDeleteCall(state, url, params);
};

export default { deleteDigitalSalesApplication };
